import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import MatchedHits from './MatchedHits';
import SalvPage from '../../common/SalvPage';
import SearchPanel from './SearchPanel';
import { InternalApiScreeningManualSearchHit } from '../../api-internal';
import './ManualSanctionCheckPage.scss';

export type SearchResult = {
  name?: string;
  hits: InternalApiScreeningManualSearchHit[];
};

const ManualSanctionCheckPage = () => {
  const [results, setResults] = useState<SearchResult>({ hits: [] });

  return (
    <SalvPage title={'Manual Screening search'} className={'manual-sanction-check-page'}>
      <Row>
        <Col md={4}>
          <div className='sticky-top'>
            <SearchPanel setResults={setResults} />
          </div>
        </Col>
        <Col md={8}>
          {results.hits.length > 0 ? (
            <MatchedHits hits={results.hits} />
          ) : (
            <div className='card-body text-center'>
              <FontAwesomeIcon icon={faMagnifyingGlass} className='fe m-5' size='4x' />
              <h1>No results yet.</h1>
              {results.name ? (
                <p className='text-muted'>
                  Search for <b>{results.name}</b> has no results
                </p>
              ) : (
                <p className='text-muted'>Search to get matched results</p>
              )}
            </div>
          )}
        </Col>
      </Row>
    </SalvPage>
  );
};

export default ManualSanctionCheckPage;
